export const isInputEvent = (event) => 
    event.target.tagName === 'INPUT' ||
    event.target.tagName === 'TEXTAREA';
 
